export const reportTranslation = {
  en: {
    Reports: "Reports",
    "All Submissions": "All Submissions",
    "Submission Completed": "Submission Completed",
    "Submission Declined": "Submission Declined",
    "Submission Pending": "Submission Pending",
    "All Templates": "All Templates",
    "Templates Archived": "Templates Archived",
    Invoices: "Invoices",
    "Active Subscriptions": "Active Subscriptions",
    "Recent Submissions": "Recent Submissions",
    "All Users": "All Users",
    "Users Verified (Nafath)": "Users Verified (Nafath)",
    "Last 5 Submissions": "Last 5 Submissions",
    "Last 5 Users": "Last 5 Users",
    "Last 5 Templates": "Last 5 Templates",
    "Last 5 invoices": "Last 5 Invoices",
    Home: "Home",
    Loading: "Loading...",
    Username: "Username",
    title: "Title",
    Link: "Link",
    "Is archived": "Is archived",
    "Last Updated": "Last Updated",
    Status: "Status",
    Email: "Email",
    Phone: "Phone",
    "Is Nafath Verified": "Is Nafath Verified",
    "Account Type": "Account Type",
    "Created At": "Created At",
    "Template Folder": "Template Folder",
    "Template Name": "Template Name",
    "Template File": "Template File",
    "Last Update": "Last Update",
    "Invoice Link": "Invoice Link",
    "Total Amount": "Total Amount",
    "Payment Type": "Payment Type",
    Teams: "Teams",
    Companies: "Companies",
    "From": "From",
    "Before": "Before",
    "Find Report": "Find Report",
    "The 'From' date cannot be later than the 'Before' date.": "The 'From' date cannot be later than the 'Before' date.",
    "Please select both 'From' and 'Before' dates.": "Please select both 'From' and 'Before' dates.",
    "Choose date range for report": "Choose date range for report",
    "Clear": "Clear"
  },
  ar: {
    Reports: "التقارير",
    "All Submissions": "جميع التقديمات",
    "Submission Completed": "التقديمات المكتملة",
    "Submission Declined": "التقديمات المرفوضة",
    "Submission Pending": "التقديمات المعلقة",
    "All Templates": "جميع القوالب",
    "Templates Archived": "القوالب المؤرشفة",
    Invoices: "الفواتير",
    "Active Subscriptions": "الاشتراكات النشطة",
    "Recent Submissions": "التقديمات الأخيرة",
    "All Users": "جميع المستخدمين",
    "Users Verified (Nafath)": "المستخدمون الذين تم التحقق منهم (نفاذ)",
    "Last 5 Submissions": "آخر 5 تقديمات",
    "Last 5 Users": "آخر 5 مستخدمين",
    "Last 5 Templates": "آخر 5 قوالب",
    "Last 5 invoices": "آخر 5 فواتير",
    Home: "الصفحة الرئيسية",
    Loading: "جار التحميل...",
    Username: "اسم المستخدم",
    title: "العنوان",
    Link: "الرابط",
    "Is archived": "مؤرشف",
    "Last Updated": "آخر تحديث",
    Status: "الحالة",
    Email: "البريد الإلكتروني",
    Phone: "رقم الهاتف",
    "Is Nafath Verified": "تم التحقق من نفاذ",
    "Account Type": "نوع الحساب",
    "Created At": "تاريخ الإنشاء",
    "Template Folder": "مجلد القالب",
    "Template Name": "اسم القالب",
    "Template File": "ملف القالب",
    "Last Update": "آخر تحديث",
    "Invoice Link": "رابط الفاتورة",
    "Total Amount": "المبلغ الإجمالي",
    "Payment Type": "نوع الدفع",
    Teams: "الفرق",
    Companies: "الشركات",
    "From": "من",
    "Before": "قبل",
    "Find Report": "ابحث عن تقرير",
    "The 'From' date cannot be later than the 'Before' date.": "لا يمكن أن يكون تاريخ 'من' لاحقًا من تاريخ 'قبل'.",
    "Please select both 'From' and 'Before' dates.": "يرجى اختيار كلا التاريخين 'من' و 'قبل'.",
    "Choose date range for report": "اختر نطاق التاريخ للتقرير",
    "Clear": "مسح"
  },
};
